var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MuiAvatar from "@mui/material/Avatar";
import { AvatarStyles } from "./Avatar.styles";
export var Avatar = function (_a) {
    var className = _a.className, color = _a.color, outline = _a.outline, size = _a.size, sx = _a.sx, others = __rest(_a, ["className", "color", "outline", "size", "sx"]);
    var defaultStyles = AvatarStyles(color, outline, size);
    return _jsx(MuiAvatar, __assign({ sx: __assign(__assign({}, defaultStyles), sx) }, others));
};
